import DateTimeHelper from "@/mixins/DateTimeHelper";
import i18n from "../locale/languages";
import { mapGetters } from 'vuex'

export default {
  mixins: [DateTimeHelper],
  computed: {
    ...mapGetters([
      'type'
    ]),
    Step1IsValid() {
      if (
        this.reservation.pickupDateTime &&
        this.reservation.returnDateTime &&
        this.reservation.pickupDateTime < this.reservation.returnDateTime &&
        this.reservation.location &&
        this.reservation.location.id
      ) {
        if (this.LocationIsAirport) {
          return (
            this.reservation.flight.arrivalDateTime &&
            this.reservation.flight.flightNumber
          );
        } else if (this.LocationIsCustom) {
          return this.reservation.customLocation;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    Step2IsValid() {
      return this.Step1IsValid && this.reservation.car !== null;
    },
    Step3IsValid() {
      if (this.SortedSelectedAdditionalChargesPrices) {
        return (
          this.Step2IsValid &&
          this.SortedSelectedAdditionalChargesPrices.length > 0
        );
      } else {
        return false;
      }
    },
    Step4IsValid() {
      if (this.reservation.contact && this.reservation.agreeWithTerms) {
        return (
          this.Step3IsValid &&
          this.reservation.contact.firstName &&
          this.reservation.contact.lastName &&
          this.reservation.contact.emailAddress &&
          this.reservation.contact.country &&
          this.reservation.contact.mobileNumber &&
          this.reservation.contact.dateOfBirth &&
          this.DateOfBirthIsValid
        );
      } else {
        return false;
      }
    },
    DateOfBirthIsValid() {
      var minimumRentalAge = this.reservation.car.minimum_rental_age;
      if(minimumRentalAge == null)
      {
        minimumRentalAge = 18;
      }

      if ( this.reservation.contact.dateOfBirth ) {
        return this.differenceBetweenDateTimesInYears(this.getDateMinYears(), this.reservation.contact.dateOfBirth) >= minimumRentalAge
      }
      else return true
    },
    PickupDateTimeToDateTimePickerString: function() {
      return this.reservation.pickupDateTime;
    },
    PickupDateTimeFormatted: function() {
      if(this.type == 'Dive') {
        return this.getLocaleFormattedDate(this.reservation.pickupDateTime)
      }
      return this.getLocaleFormattedDateTime(this.reservation.pickupDateTime);
    },
    ReturnDateTimeToDateTimePickerString: function() {
      return this.getDateTimePickerFormat(this.reservation.returnDateTime);
    },
    ReturnDateTimeFormatted: function() {
      if(this.type == 'Dive') {
        return this.getLocaleFormattedDate(this.reservation.returnDateTime)
      }
      return this.getLocaleFormattedDateTime(this.reservation.returnDateTime);
    },
    NumberOfDays: function() {
      return Math.ceil(this.NumberOfHours / 24);
    },
    NumberOfHours: function() {
      return this.differenceBetweenDateTimesInHours(
        this.reservation.returnDateTime,
        this.reservation.pickupDateTime
      );
    },
    LocationIsAirport: function() {
      if (this.reservation.location) {
        return this.reservation.location.is_airport
      } else {
        return false
      }
    },
    LocationIsCustom: function() {
      if (this.reservation.location) {
        return (
          this.reservation.location.is_custom === true
        );
      } else {
        return false;
      }
    },
    LocationName: function() {
      if (this.reservation.location) {
        return this.reservation.location.name
      } else {
        return null
      }
    },
    ReturnLocationName() {
      if ( this.reservation.returnLocation ) {
        return this.reservation.returnLocation.name
      } else {
        return null
      }
    },
    ArrivalDateTimeToDateTimePickerString: function() {
      if (this.reservation.flight && this.reservation.flight.arrivalDateTime) {
        return this.getDateTimePickerFormat(
          this.reservation.flight.arrivalDateTime
        );
      }
    },
    ArrivalDateTimeFormatted: function() {
      return this.getLocaleFormattedDateTime(
        this.reservation.flight.arrivalDateTime
      );
    },
    FlightInformation: function() {
      return (
        this.reservation.flight.flightNumber +
        " - " +
        this.ArrivalDateTimeFormatted
      );
    },
    CarName: function() {
      if (this.reservation.car) {
        return this.reservation.car.vehicle_class.label;
      } else {
        return null;
      }
    },
    CarRate: function() {
      if (this.reservation.car) {
        return parseFloat(this.reservation.car.rate.amount);
      } else {
        return null;
      }
    },
    CarTotalRate: function() {
      if (this.reservation.car) {
        return this.CarRate * this.NumberOfDays;
      } else {
        return null;
      }
    },
	getPriceDetails: function() {
		let priceDetails = [];
		if (this.reservation.additionalChargesPrices &&
			this.reservation.additionalChargesPrices.selected_vehicle_class &&
			this.reservation.additionalChargesPrices.selected_vehicle_class.price &&
			this.reservation.additionalChargesPrices.selected_vehicle_class.price.details) {
		  priceDetails = this.reservation.additionalChargesPrices.selected_vehicle_class.price.details.map(item => {
			return {
			  days: item.total_days,
			  price: parseFloat(item.base_daily_price.amount) || 0,
			  total: parseFloat(item.total_price.amount) || 0
			};
		  });
		}
		return priceDetails;
	  },
    SortedSelectedAdditionalChargesPrices: function() {
      if (
        this.reservation.additionalChargesPrices &&
        this.reservation.additionalChargesPrices.selectedAdditionalCharges
      ) {
        return this.reservation.additionalChargesPrices.selectedAdditionalCharges
          .slice()
          .sort((a, b) => {
            return a.order == null ? b.order - a.order : a.order - b.order;
          });
      } else {
        return null;
      }
    },
    SortedSelectedAdditionalChargesInsurancePrices: function() {
      if (
        this.reservation.additionalChargesPrices &&
        this.reservation.additionalChargesPrices.selectedAdditionalCharges
      ) {
        return this.reservation.additionalChargesPrices.selectedAdditionalCharges
          .filter(acp => {
            let additionalCharge = this.reservation.availableAdditionalCharges.find(
              ac => {
                return acp.id == ac.id;
              }
            );
            if (additionalCharge) {
              return additionalCharge.insurance_charge;
            } else {
              return false;
            }
          })
          .slice()
          .sort((a, b) => {
            return a.order - b.order;
          });
      } else {
        return null;
      }
    },
    SortedSelectedAdditionalChargesServicePrices: function() {
      if (
        this.reservation.additionalChargesPrices &&
        this.reservation.additionalChargesPrices.selectedAdditionalCharges
      ) {
        return this.reservation.additionalChargesPrices.selectedAdditionalCharges
          .filter(acp => {
            let additionalCharge = this.reservation.availableAdditionalCharges.find(
              ac => {
                return acp.id == ac.id;
              }
            );
            if (additionalCharge) {
              return !additionalCharge.insurance_charge;
            } else {
              return true;
            }
          })
          .slice()
          .sort((a, b) => {
            return a.order - b.order;
          });
      } else {
        return null;
      }
    },
    ApplicableTaxes: function() {
      if (this.reservation.additionalChargesPrices) {
        return this.reservation.additionalChargesPrices.applicable_taxes;
      } else {
        return null;
      }
    },
    HasDiscounts: function() {
      if (this.reservation.additionalChargesPrices) {
        return (
          this.reservation.additionalChargesPrices.applicable_discounts.length >
          0
        );
      } else {
        return false;
      }
    },
    ApplicableDiscounts: function() {
      if (this.reservation.additionalChargesPrices) {
        return this.reservation.additionalChargesPrices.applicable_discounts;
      } else {
        return null;
      }
    },
    CarPriceWithDiscount: function() {
      if (
        this.reservation.additionalChargesPrices &&
        this.reservation.additionalChargesPrices.selected_vehicle_class &&
        this.reservation.additionalChargesPrices.selected_vehicle_class.price &&
        this.reservation.additionalChargesPrices.selected_vehicle_class.price
          .base_price
      ) {
        return parseFloat(
          this.reservation.additionalChargesPrices.selected_vehicle_class.price
            .base_price.amount
        );
      } else {
        return null;
      }
    },
    CarPriceInclDiscountAndAdditionalCharges() {
       let car = this.CarPriceWithDiscount
       let additionalCharges = 0
       if (
        this.reservation.additionalChargesPrices &&
        this.reservation.additionalChargesPrices.selectedAdditionalCharges
      )
      {
        this.reservation.additionalChargesPrices.selectedAdditionalCharges.forEach(x => {
          additionalCharges += parseFloat(x.base_price.amount)
        })
      }
      return (car + additionalCharges)
    },
    TotalTax() {
      let tax = 0
      if ( this.ApplicableTaxes ) {
        this.ApplicableTaxes.forEach(x => {
          tax += parseFloat(x.total_amount.amount)
        })
      }
      return tax
    },
    TotalPrice: function() {
      if (
        this.reservation.additionalChargesPrices &&
        this.reservation.additionalChargesPrices.total &&
        this.reservation.additionalChargesPrices.total.total_price
      ) {
        return parseFloat(
          this.reservation.additionalChargesPrices.total.total_price.amount
        );
      } else {
        return null;
      }
    },
    ContactFullName: function() {
      if (this.Step4IsValid) {
        let fullName = this.reservation.contact.firstName;
        if (this.reservation.contact.middleName) {
          fullName += " " + this.reservation.contact.middleName;
        }
        fullName += " " + this.reservation.contact.lastName;
        return fullName;
      } else {
        return null;
      }
    },
    ContactAddress: function() {
      if (this.Step4IsValid && this.reservation.contact.address) {
        return this.reservation.contact.address;
      } else {
        return null;
      }
    },
    ContactZip: function() {
      if (this.Step4IsValid && this.reservation.contact.zip) {
        return this.reservation.contact.zip;
      } else {
        return null;
      }
    },
    ContactCity: function() {
      if (this.Step4IsValid && this.reservation.contact.city) {
        return this.reservation.contact.city;
      } else {
        return null;
      }
    },
    ContactCountry: function() {
      if (this.Step4IsValid) {
        return this.reservation.contact.country.label;
      } else {
        return null;
      }
    },
    ContactState: function() {
      if (this.Step4IsValid && this.reservation.contact.state) {
        return this.reservation.contact.state;
      } else {
        return null;
      }
    },
    ContactEmail: function() {
      if (this.Step4IsValid) {
        return this.reservation.contact.emailAddress;
      } else {
        return null;
      }
    },
    ContactPhone: function() {
      if (this.Step4IsValid && this.reservation.contact.phoneNumber) {
        return this.reservation.contact.phoneNumber;
      } else {
        return null;
      }
    },
    ContactMobile: function() {
      if (this.Step4IsValid && this.reservation.contact.mobileNumber) {
        return this.reservation.contact.mobileNumber;
      } else {
        return null;
      }
    },
    ContactDateOfBirth: function() {
      if (
        this.Step4IsValid &&
        this.reservation.contact &&
        this.reservation.contact.dateOfBirth &&
        this.reservation.contact.dateOfBirth !== "Invalid date"
      ) {
        return this.getLocaleFormattedDate(
          this.reservation.contact.dateOfBirth
        );
      } else {
        return null;
      }
    },
    HasContactIdentification: function() {
      return (
        this.Step4IsValid &&
        this.reservation.contact &&
        this.reservation.contact.identification &&
        this.reservation.contact.identification.length > 0 &&
        this.reservation.contact.identification[0].identificationNumber &&
        this.reservation.contact.identification[0].expirationDate &&
        this.reservation.contact.identification[0].expirationDate !==
          "Invalid date"
      );
    }
  },
  methods: {
    getAdditionalChargeInsuranceByIndex: function(index) {
      if (this.SortedSelectedAdditionalChargesInsurancePrices) {
        return this.SortedSelectedAdditionalChargesInsurancePrices[index];
      } else {
        return null;
      }
    },
    getAdditionalChargeInsuranceTotalRateByIndex: function(index) {
      let ac = this.getAdditionalChargeInsuranceByIndex(index);
      if (ac) {
        return parseFloat(ac.total_price.amount);
      }
    },
    getInsuranceQuantityByIndex: function(index) {
      let ac = this.getAdditionalChargeInsuranceByIndex(index);
      if (ac && ac.selected_quantity > 1) {
        return ac.selected_quantity + " x ";
      } else {
        return "";
      }
    },
    getAdditionalChargeServiceByIndex: function(index) {
      if (this.SortedSelectedAdditionalChargesServicePrices) {
        return this.SortedSelectedAdditionalChargesServicePrices[index];
      } else {
        return null;
      }
    },
    getAdditionalChargeServiceTotalRateByIndex: function(index) {
      let ac = this.getAdditionalChargeServiceByIndex(index);
      if (ac) {
        return parseFloat(ac.total_price.amount);
      }
    },
    getServiceQuantityByIndex: function(index) {
      let ac = this.getAdditionalChargeServiceByIndex(index);
      if (ac && ac.selected_quantity > 1) {
        return ac.selected_quantity + " x ";
      } else {
        return "";
      }
    },
    getTaxPriceByIndex: function(index) {
      if (this.reservation.additionalChargesPrices) {
        let tax = this.reservation.additionalChargesPrices.applicable_taxes[
          index
        ];
        if (tax) {
          return parseFloat(tax.total_amount.amount);
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    getDiscountPriceByIndex: function(index) {
      if (this.reservation.additionalChargesPrices) {
        let discount = this.reservation.additionalChargesPrices
          .applicable_discounts[index];
        if (discount) {
          return parseFloat(discount.discounted_amount.amount);
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    getAdditionalChargeById(id) {
      if (this.reservation.additionalCharges) {
        return this.reservation.additionalCharges.find(ac => {
          return ac.id == id;
        });
      }
    },
    getAvailableAdditionalChargeById(id) {
      if (this.reservation.availableAdditionalCharges) {
        return this.reservation.availableAdditionalCharges.find(ac => {
          return ac.id == id;
        });
      }
    },
    getTranslatedLabelById(id) {
      let ac = this.getAdditionalChargeById(id);
      if (ac) {
        let aac = this.getAvailableAdditionalChargeById(id);
        if (aac) {
          let label = aac.label_for_website[i18n.locale];
          if (label == "") {
            label = aac.label_for_website[i18n.fallbackLocale];
          }

          if (label == null || label == '' ) {
            label= aac.name
        }

          return label;
        }
      }
    },
    getIdentificationTypeByIndex: function(index) {
      if (
        this.HasContactIdentification &&
        index < this.reservation.contact.identification.length
      ) {
        return this.reservation.contact.identification[index]
          .identificationType;
      } else {
        return null;
      }
    },
    getIdentificationNumberByIndex: function(index) {
      if (
        this.HasContactIdentification &&
        index < this.reservation.contact.identification.length
      ) {
        return this.reservation.contact.identification[index]
          .identificationNumber;
      } else {
        return null;
      }
    },
    getIdentificationExpirationDateByIndex: function(index) {
      if (
        this.HasContactIdentification &&
        index < this.reservation.contact.identification.length
      ) {
        return this.getLocaleFormattedDate(
          this.reservation.contact.identification[index].expirationDate
        );
      } else {
        return null;
      }
    }
  }
};
